<form class="content" [formGroup]="allergiesForm" (submit)="submit()">
  <span>{{ 'do_you_have_any_allergies' | translate }}</span>
  <mat-radio-group formControlName="no_allergies">
    <mat-radio-button
      class="radio-group"
      *ngFor="
        let option of [
          { value: 'true', name: 'yes' },
          { value: 'false', name: 'no' },
        ]
      "
      [value]="option.value"
    >
      {{ option.name | translate }}
    </mat-radio-button>
  </mat-radio-group>
  <div class="warning">
    <mat-form-field class="text">
      <mat-label>{{ 'warning_note_for_practitioner' | translate }}</mat-label>
      <textarea matInput type="text" name="warning" formControlName="warning" gcFormField gcFormFieldNoError></textarea>
    </mat-form-field>
    <mat-checkbox formControlName="urgent" class="checkbox">{{ 'important?' | translate }}</mat-checkbox>
  </div>

  <mat-accordion multi="true">
    <mat-expansion-panel>
      <mat-expansion-panel-header class="accordion-description">{{ 'drug_classes' | translate }}</mat-expansion-panel-header>
      <div class="allergies-group">
        <form class="allergy-form" [formGroup]="newDrugAllergyForm" (submit)="addAllergyItem('drug_classes')">
          <div class="new-group">
            <div formGroupName="allergy">
              <mat-form-field class="max-width">
                <mat-select formControlName="description" gcFormField gcFormFieldNoError placeholder="{{ 'choose' | translate }}...">
                  <mat-option *ngFor="let option of drugClassesOptions" [value]="option.description">
                    {{ option.description }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <mat-form-field *ngIf="newDrugAllergyForm.controls.allergy.value.description" class="note">
              <mat-label>{{ 'add_a_note' | translate }}</mat-label>
              <input matInput type="text" name="note" formControlName="note" gcFormField gcFormFieldNoError />
            </mat-form-field>
          </div>
          <div class="center">
            <button mat-flat-button type="submit" class="add-button" [disabled]="!newDrugAllergyForm.controls.allergy.value.description">
              <mat-icon svgIcon="plus"></mat-icon>
              {{ 'add_drug_allergy' | translate }}
            </button>
          </div>
        </form>
        <div *ngIf="drugAllergyList.controls.length" class="divider"></div>
        <form class="allergy-form" [formGroup]="allergiesForm">
          <div formArrayName="drug_classes">
            <div *ngFor="let drugAllergyItem of drugAllergyList.controls; let i = index">
              <div [formGroupName]="i">
                <div class="title-text">{{ drugAllergyItem.value.description }}</div>
                <div class="description">
                  <mat-form-field class="note">
                    <textarea matInput type="text" formControlName="note" gcFormField gcFormFieldNoError></textarea>
                  </mat-form-field>
                  <button class="delete-button" mat-raised-button color="warn" (click)="remove('drug_classes', i)">
                    <mat-icon svgIcon="delete"></mat-icon>
                    {{ 'delete' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header class="accordion-description">{{ 'natural_allergies' | translate }}</mat-expansion-panel-header>
      <div class="allergies-group">
        <form class="allergy-form" [formGroup]="newNaturalAllergyForm" (submit)="addAllergyItem('natural_ingredients')">
          <div class="new-group">
            <div formGroupName="allergy">
              <mat-form-field class="max-width">
                <mat-select formControlName="description" gcFormField gcFormFieldNoError placeholder="{{ 'choose' | translate }}...">
                  <mat-option *ngFor="let option of naturalIngredientsOptions" [value]="option.description">
                    {{ option.description | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <mat-form-field *ngIf="newNaturalAllergyForm.controls.allergy.value" class="note">
              <mat-label>{{ 'add_a_note' | translate }}</mat-label>
              <input matInput type="text" name="note" formControlName="note" gcFormField gcFormFieldNoError />
            </mat-form-field>
          </div>
          <div class="center">
            <button mat-flat-button type="submit" class="add-button" [disabled]="!newNaturalAllergyForm.controls.allergy.value.description">
              <mat-icon svgIcon="plus"></mat-icon>
              {{ 'add_natural_allergy' | translate }}
            </button>
          </div>
        </form>
        <div *ngIf="naturalAllergyList.controls.length" class="divider"></div>
        <form class="allergy-form" [formGroup]="allergiesForm">
          <div formArrayName="natural_ingredients">
            <div *ngFor="let naturalAllergyItem of naturalAllergyList.controls; let i = index">
              <div [formGroupName]="i">
                <div class="title-text">{{ naturalAllergyItem.value.description | translate }}</div>
                <div class="description">
                  <mat-form-field class="note">
                    <textarea matInput type="text" formControlName="note" gcFormField gcFormFieldNoError></textarea>
                  </mat-form-field>
                  <button class="delete-button" mat-raised-button color="warn" (click)="remove('natural_ingredients', i)">
                    <mat-icon svgIcon="delete"></mat-icon>
                    {{ 'delete' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header class="accordion-description">{{ 'chemical_allergies' | translate }}</mat-expansion-panel-header>
      <div class="allergies-group">
        <form class="allergy-form" [formGroup]="newChemicalAllergyForm" (submit)="addAllergyItem('chemical_ingredients')">
          <div class="new-group">
            <div formGroupName="allergy">
              <mat-form-field class="max-width">
                <input
                  #input_chemical_allergy
                  type="text"
                  placeholder="{{ 'type_to_search' | translate }}..."
                  matInput
                  [matAutocomplete]="auto"
                  formControlName="description"
                  (input)="filterChemicalAllery()"
                  (focus)="filterChemicalAllery()"
                />
                <mat-autocomplete #auto="matAutocomplete" requireSelection gcFormField gcFormFieldNoError placeholder="Type to search...">
                  <mat-option *ngFor="let option of medicineIngredientsOptions | slice: 1 : 10" [value]="option.description">
                    {{ option.description }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <mat-form-field *ngIf="newChemicalAllergyForm.controls.allergy.value.description" class="note">
              <mat-label>{{ 'add_a_note' | translate }}</mat-label>
              <input matInput type="text" name="note" formControlName="note" gcFormField gcFormFieldNoError />
            </mat-form-field>
          </div>
          <div class="center">
            <button
              mat-flat-button
              type="submit"
              class="add-button"
              [disabled]="!newChemicalAllergyForm.controls.allergy.value.description"
            >
              <mat-icon svgIcon="plus"></mat-icon>
              {{ 'add_chemical_allergy' | translate }}
            </button>
          </div>
        </form>
        <div *ngIf="chemicalAllergyList.controls.length" class="divider"></div>
        <form class="allergy-form" [formGroup]="allergiesForm">
          <div formArrayName="chemical_ingredients">
            <div *ngFor="let chemicalAllergyItem of chemicalAllergyList.controls; let i = index">
              <div [formGroupName]="i">
                <div class="title-text">{{ chemicalAllergyItem.value.description }}</div>
                <div class="description">
                  <mat-form-field class="note">
                    <textarea matInput type="text" formControlName="note" gcFormField gcFormFieldNoError></textarea>
                  </mat-form-field>
                  <button class="delete-button" mat-raised-button color="warn" (click)="remove('chemical_ingredients', i)">
                    <mat-icon svgIcon="delete"></mat-icon>
                    {{ 'delete' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <div class="center">
    <button class="save-button" [ngClass]="{ primary: requestUuid === null, accent: requestUuid !== null }" mat-flat-button type="submit">
      <mat-icon svgIcon="check"></mat-icon>
      {{ 'save_allergies' | translate }}
    </button>
  </div>
</form>
